"use client";

import { c as _c } from "react/compiler-runtime";
import { FC, useEffect, useState } from "react";
import { ApiWaveOutcome } from "@/generated/models/ApiWaveOutcome";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressCard } from "@fortawesome/free-regular-svg-icons";
interface WaveNICOutcomeProps {
  readonly outcome: ApiWaveOutcome;
}
const DEFAULT_AMOUNTS_TO_SHOW = 3;
export const WaveNICOutcome: FC<WaveNICOutcomeProps> = t0 => {
  const $ = _c(54);
  const {
    outcome
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const winnersCount = outcome.distribution?.filter(_temp).length ?? 0;
  const totalCount = outcome.distribution?.length ?? 0;
  let t1;
  if ($[0] !== outcome.distribution || $[1] !== showAll) {
    t1 = () => {
      if (showAll) {
        return outcome.distribution?.map(_temp2) ?? [];
      }
      return outcome.distribution?.slice(0, DEFAULT_AMOUNTS_TO_SHOW).map(_temp3) ?? [];
    };
    $[0] = outcome.distribution;
    $[1] = showAll;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getAmounts = t1;
  let t2;
  if ($[3] !== getAmounts) {
    t2 = getAmounts();
    $[3] = getAmounts;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const [amounts, setAmounts] = useState(t2);
  let t3;
  if ($[5] !== getAmounts) {
    t3 = () => {
      setAmounts(getAmounts());
    };
    $[5] = getAmounts;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== showAll) {
    t4 = [showAll];
    $[7] = showAll;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
  const t5 = "tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-border-iron-800 tw-transition-all tw-duration-300 desktop-hover:hover:tw-border-iron-700";
  const t6 = "button";
  let t7;
  if ($[9] !== isOpen) {
    t7 = () => setIsOpen(!isOpen);
    $[9] = isOpen;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = "tw-w-full tw-border-0 tw-px-4 tw-py-3 tw-bg-iron-950";
  const t9 = "tw-flex tw-items-center tw-justify-between";
  const t10 = "tw-flex tw-items-center tw-gap-4";
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="tw-flex tw-items-center tw-justify-center tw-size-10 tw-rounded-xl tw-bg-gradient-to-br tw-from-[#A4C2DB]/20 tw-to-[#A4C2DB]/10 tw-shadow-inner"><FontAwesomeIcon icon={faAddressCard} className="tw-size-5 tw-text-[#A4C2DB] tw-flex-shrink-0 tw-drop-shadow-[0_0_3px_rgba(164,194,219,0.5)]" /></div>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const t12 = "tw-text-left";
  let t13;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="tw-text-base tw-font-semibold tw-text-[#A4C2DB]">NIC</div>;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  const t14 = "tw-text-sm tw-text-[#A4C2DB]/80";
  const t15 = formatNumberWithCommas(winnersCount);
  const t16 = winnersCount === 1 ? "Winner" : "Winners";
  let t17;
  if ($[13] !== t15 || $[14] !== t16) {
    t17 = <div className={t14}>{t15}{" "}{t16}</div>;
    $[13] = t15;
    $[14] = t16;
    $[15] = t17;
  } else {
    t17 = $[15];
  }
  let t18;
  if ($[16] !== t13 || $[17] !== t17) {
    t18 = <div className={t12}>{t13}{t17}</div>;
    $[16] = t13;
    $[17] = t17;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] !== t11 || $[20] !== t18) {
    t19 = <div className={t10}>{t11}{t18}</div>;
    $[19] = t11;
    $[20] = t18;
    $[21] = t19;
  } else {
    t19 = $[21];
  }
  const t20 = outcome.amount ?? 0;
  let t21;
  if ($[22] !== t20) {
    t21 = formatNumberWithCommas(t20);
    $[22] = t20;
    $[23] = t21;
  } else {
    t21 = $[23];
  }
  let t22;
  if ($[24] !== t21) {
    t22 = <div className="tw-text-base tw-font-semibold tw-text-[#A4C2DB]">{t21}</div>;
    $[24] = t21;
    $[25] = t22;
  } else {
    t22 = $[25];
  }
  let t23;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="tw-text-xs tw-text-iron-400">total pool</div>;
    $[26] = t23;
  } else {
    t23 = $[26];
  }
  let t24;
  if ($[27] !== t22) {
    t24 = <div className="tw-text-right">{t22}{t23}</div>;
    $[27] = t22;
    $[28] = t24;
  } else {
    t24 = $[28];
  }
  const t25 = isOpen ? 0 : -90;
  let t26;
  if ($[29] !== t25) {
    t26 = {
      rotate: t25
    };
    $[29] = t25;
    $[30] = t26;
  } else {
    t26 = $[30];
  }
  let t27;
  let t28;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = {
      duration: 0.2
    };
    t28 = <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />;
    $[31] = t27;
    $[32] = t28;
  } else {
    t27 = $[31];
    t28 = $[32];
  }
  let t29;
  if ($[33] !== t26) {
    t29 = <motion.svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" aria-hidden="true" className="tw-flex-shrink-0 tw-size-4 tw-text-iron-400" animate={t26} transition={t27}>{t28}</motion.svg>;
    $[33] = t26;
    $[34] = t29;
  } else {
    t29 = $[34];
  }
  let t30;
  if ($[35] !== t24 || $[36] !== t29) {
    t30 = <div className="tw-flex tw-items-center tw-gap-3">{t24}{t29}</div>;
    $[35] = t24;
    $[36] = t29;
    $[37] = t30;
  } else {
    t30 = $[37];
  }
  let t31;
  if ($[38] !== t19 || $[39] !== t30) {
    t31 = <div className={t9}>{t19}{t30}</div>;
    $[38] = t19;
    $[39] = t30;
    $[40] = t31;
  } else {
    t31 = $[40];
  }
  let t32;
  if ($[41] !== t31 || $[42] !== t7) {
    t32 = <button type={t6} onClick={t7} className={t8}>{t31}</button>;
    $[41] = t31;
    $[42] = t7;
    $[43] = t32;
  } else {
    t32 = $[43];
  }
  let t33;
  if ($[44] !== amounts || $[45] !== isOpen || $[46] !== showAll || $[47] !== totalCount) {
    t33 = isOpen && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: "auto",
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="tw-overflow-hidden tw-bg-gradient-to-b tw-from-iron-900/50 tw-to-iron-950/50"><div className="tw-divide-y tw-divide-iron-800/30 tw-divide-solid tw-divide-x-0">{amounts.map(_temp4)}{!showAll && totalCount > DEFAULT_AMOUNTS_TO_SHOW && <button onClick={() => setShowAll(true)} className="tw-border-0 tw-w-full tw-px-4 tw-py-3 tw-text-left tw-bg-iron-900 tw-text-[#A4C2DB]/80 tw-text-sm hover:tw-text-[#A4C2DB] tw-transition-all tw-duration-300"><span>View more</span><span className="tw-ml-1 tw-text-iron-400">•</span><span className="tw-ml-1 tw-text-iron-400">{totalCount - DEFAULT_AMOUNTS_TO_SHOW} more</span></button>}</div></motion.div>;
    $[44] = amounts;
    $[45] = isOpen;
    $[46] = showAll;
    $[47] = totalCount;
    $[48] = t33;
  } else {
    t33 = $[48];
  }
  let t34;
  if ($[49] !== t33) {
    t34 = <AnimatePresence initial={false}>{t33}</AnimatePresence>;
    $[49] = t33;
    $[50] = t34;
  } else {
    t34 = $[50];
  }
  let t35;
  if ($[51] !== t32 || $[52] !== t34) {
    t35 = <div className={t5}>{t32}{t34}</div>;
    $[51] = t32;
    $[52] = t34;
    $[53] = t35;
  } else {
    t35 = $[53];
  }
  return t35;
};
function _temp(d) {
  return !!d.amount;
}
function _temp2(d_0) {
  return d_0?.amount ?? 0;
}
function _temp3(d_1) {
  return d_1?.amount ?? 0;
}
function _temp4(amount, i) {
  return <div key={`wave-nic-outcome-${amount}-${i}`} className="tw-px-4 tw-py-3 tw-bg-gradient-to-r hover:tw-from-[#A4C2DB]/5 hover:tw-to-transparent tw-transition-colors tw-duration-300"><div className="tw-flex tw-items-center tw-gap-4"><span className="tw-flex tw-items-center tw-justify-center tw-size-8 tw-rounded-lg tw-bg-gradient-to-br tw-from-[#A4C2DB]/10 tw-to-[#A4C2DB]/5 tw-text-[#A4C2DB] tw-text-sm tw-font-semibold">{i + 1}</span><span className="tw-whitespace-nowrap tw-text-[#A4C2DB] tw-text-base tw-font-medium">{formatNumberWithCommas(amount)} NIC</span></div></div>;
}